/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-09-08 16:38:58
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 14:02:48
 */
/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-30 11:14:14
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-08 14:59:56
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Cascader,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  notification,
  Radio,
  Row,
  Select,
  Switch,
  TimePicker,
  Tree,
} from 'antd'
import { DataNode } from 'antd/lib/tree'
import _ from 'lodash'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectEdition } from '../../../../app/applicationSlice'
import { RootDispatch } from '../../../../app/store'
import { PayMethod } from '../../../../models/payment'
import { Checks, Settinglable, Settings } from '../../../../models/setting'
import { Tenant } from '../../../../models/tenant'
import { setSettings } from '../../../settings/settingsSlice'
import {
  selectSettings,
  selectTenant,
  selectAutoCreateFeeVOList,
  saveSettingLabel,
  setIsChange,
  getSettingDetail,
} from '../../../user/setting/settingSlice'
import styles from '../../functionSettingTabs.module.css'

export const StatisticalSettings = (props: {
  selectedTab: any
}): ReactElement => {
  const [form] = Form.useForm()

  const { Option } = Select
  
  const dispatch = useDispatch<RootDispatch>()

  const settings = useSelector(selectSettings)

  const tenant = useSelector(selectTenant)

  const [buttonLoading, setButtonLoading] = useState(false)

  const dateCarriedForward = [
    { value: 1, name: 1 },
    { value: 2, name: 2 },
    { value: 3, name: 3 },
    { value: 4, name: 4 },
    { value: 5, name: 5 },
    { value: 6, name: 6 },
    { value: 7, name: 7 },
    { value: 8, name: 8 },
    { value: 9, name: 9 },
    { value: 10, name: 10 },
    { value: 11, name: 11 },
    { value: 12, name: 12 },
    { value: 13, name: 13 },
    { value: 14, name: 14 },
    { value: 15, name: 15 },
    { value: 16, name: 16 },
    { value: 17, name: 17 },
    { value: 18, name: 18 },
    { value: 19, name: 19 },
    { value: 20, name: 20 },
    { value: 21, name: 21 },
    { value: 22, name: 22 },
    { value: 23, name: 23 },
    { value: 24, name: 24 },
    { value: 25, name: 25 },
    { value: 26, name: 26 },
    { value: 27, name: 27 },
    { value: 28, name: 28 },
    { value: 29, name: 29 },
    { value: 30, name: 30 },
    { value: 31, name: 31 },
    { value: 99, name: '每月最后一天' },
  ]

  useEffect(() => {
    if (props?.selectedTab == '6') {
      if (tenant) {
        form.setFieldsValue({
          ...tenant,
          registeredFund: null,
        })
      }
      if (settings) {
        const defaultMethod =
          (parseInt(settings[Checks.Mrzffs]) as PayMethod) || PayMethod.Cash
        dispatch(
          setSettings({
            [Settings.Treatment.DoNotWarnDoctorMismatch]:
              settings[Checks.Gbkdysstx] || false,
            [Settings.Treatment.Settlement]: settings[Checks.Zjjs] || false,
            [Settings.Recipe.ChangePrice]: !(settings[Checks.Gbxgjg] || false),
            [Settings.Payment.DefautMethod]: defaultMethod,
            [Settings.Recipe.AutoChangePrice]: settings[Checks.ZDJSTS] || false,
            [Settings.Recipe.AutoChangePriceAfter]:
              settings[Checks.ZDJSTSBCH] || false,
          })
        )
        const value = settings[Checks.Zdrjsj]

        form.setFieldsValue({
          ...settings,
          [Checks.Zdrjsj]:
            value === '' || value === undefined || value === 'Invadlid date'
              ? undefined
              : moment(value, 'HH:mm'),
          [Checks.Jzrqsd]:
            settings[Checks.Jzrqsd] == 99 ? 99 : settings[Checks.Jzrqsd],
        })
      }
    }
  }, [tenant, settings, props?.selectedTab])

  useEffect(() => {
    if (props?.selectedTab == '6') {
      dispatch(getSettingDetail())
    }
  }, [props?.selectedTab])

  return (
    <Col className={styles.settingAppointment}>
      <Form
        form={form}
        onFinish={(values) => {
          const pattern = /^[0-9]*$/

          const t = _.chain(values)
            .omitBy((_, k) => pattern.test(k))
            .value() as Tenant

          const f = _.chain(values)
            .pickBy((_, k) => pattern.test(k))
            .mapValues(
              (v, k) =>
                ({
                  type: k,
                  value:
                    k === Checks.Zdrjsj.toString()
                      ? moment(v).format('HH:mm:ss')
                      : v?.toString(),
                } as Settinglable)
            )
            .values()
            .value()
          setButtonLoading(true)
          dispatch(
            saveSettingLabel({
              tenant: {
                ...tenant,
                ...t,
              },
              functionList: f,
            })
          )
            .then(unwrapResult)
            .then(() => {
              notification.success({
                message: '保存成功,部分配置需要重新登陆后生效',
                duration: 3,
              })
              dispatch(getSettingDetail())
            })
            .catch(() => {
              notification.error({ message: '机构设置保存失败', duration: 3 })
              dispatch(getSettingDetail())
            })
            .finally(() => {
              dispatch(setIsChange(false))
              setButtonLoading(false)
            })
        }}
      >
        <div style={{ overflow: 'auto', height: 'calc(100% - 40px)' }}>
          <Col className={styles.rowHeight} span={24}>
            <Form.Item label='指定日结时间' name={Checks.Zdrjsj}>
              <TimePicker format='HH:mm' style={{ width: '200px' }} />
            </Form.Item>
          </Col>
          <Col className={styles.rowHeight} span={24}>
            <Form.Item
              name={Checks.AUTODAILY}
              label='自动日结'
              valuePropName='checked'
            >
              <Switch checkedChildren='开启' unCheckedChildren='关闭'></Switch>
            </Form.Item>
            <span className={styles.nameTips}>
              开启后，销售员日期报表里每天凌晨会生成前一天的日结数据
            </span>
          </Col>
          <Col className={styles.rowHeight} span={24}>
            <Form.Item label='结转日期设定' name={Checks.Jzrqsd}>
              <Select style={{ width: '200px' }} placeholder='请选择结转日期'>
                {dateCarriedForward.map((v: any) => {
                  return (
                    <Option value={v.value} key={v.value}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>
        </div>
        <Row>
          <Col span={12}>
            <Button
              htmlType='button'
              style={{
                float: 'right',
                marginRight: '10px',
              }}
            >
              取消
            </Button>
          </Col>
          <Col span={12}>
            <Button
              loading={buttonLoading}
              type='primary'
              htmlType='submit'
              style={{
                float: 'left',
              }}
            >
              保存
            </Button>
          </Col>
        </Row>
      </Form>
    </Col>
  )
}
